<template>
    <div class="pb-5">
      <table-element
        :isShowFilter="true"
        :title="$t('Vehicles.trucks')"
        :fields="fieldsObj"
        :arrOfElement="trucks"
        :sortSpacing="0"
        class="card mx-2 mb-5"
        @updateFilterResults="updateFilterResults"
      >
        <template #header-actions>
        </template>
  
        <template #body-content-desktop="content">
          <tr v-for="(truck, index) in content.results"
          class="table-element_hover text-center"
          :key="index">
              <td class="nowrap"><p class="table-fix-width">{{truck.truckNumber}}</p></td>
              <td>{{truck.brand}}</td>
              <td class="nowrap"><p class="table-fix-width">{{truck.model}}</p></td>
              <td>{{truck.year}}</td>
              <td>{{truck.vin}}</td>
              <td>{{truck.plateNumber}}</td>
              <td v-if="!isViewer">
                <input @click.prevent="modifying(truck); setModalTitle($t('Vehicles.modifyTruckTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Vehicles.modify')">
              </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <transition-group name="fade">
            <div class="card my-3 mx-2" v-for="truck in content.results" :key="truck['.key']">
              <div class="card-header m-2">
                <h4>{{truck.truckNumber}} {{truck.brand}}</h4>
                <p><i class="fa fa-envelope mr-1" />{{truck.model}}</p>
              </div>
              <div class="m-2">
                <p><i class="fa fa-phone" /> {{truck.year}}</p>
                <p><i class="fa fa-users" /> {{truck.vin}}</p>
                <p><i class="fa fa-lock " /> {{truck.plateNumber}}</p>
                <div id="action" v-if="!isViewer">
                  <input @click.prevent="modifying(truck); setModalTitle($t('Vehicles.modifyTruckTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Vehicles.modify')">
                </div>
              </div>
            </div>
          </transition-group>
        </template>
      </table-element>
  
      <loading-render v-if="isLoading" />
  
      <!-- Modal -->
      <transition name="fade">
        <modal
          :title="modalTitle"
          v-if="add || modify"
          @close-request="add = false; modify = false; clear()"
          closable
        >
          <div>
            <label class="col-12" for="truckNumber">{{$t('Vehicles.truckNumber')}} *</label>
            <regular-input
            id="truckNumber"
            :value="truck.truckNumber"
            @input="truck.truckNumber = $event"
            type="text" :placeholder="$t('Vehicles.truckNumber')" class="col-12 form-group"/>

            <label class="col-12" for="brand">{{$t('Vehicles.brand')}} *</label>
            <regular-input
            id="brand"
            :value="truck.brand"
            @input="truck.brand = $event"
            type="text" :placeholder="$t('Vehicles.brand')" class="col-12 form-group"/>

            <label class="col-12" for="model">{{$t('Vehicles.model')}} *</label>
            <regular-input
            id="model"
            :value="truck.model"
            @input="truck.model = $event"
            type="text" :placeholder="$t('Vehicles.model')" class="col-12 form-group"/>

            <label class="col-12" for="year">{{$t('Vehicles.year')}} *</label>
            <regular-input
            id="year"
            :value="truck.year"
            @input="truck.year = $event"
            type="text" :placeholder="$t('Vehicles.year')" class="col-12 form-group"/>

            <label class="col-12" for="vin">{{$t('Vehicles.vin')}} *</label>
            <regular-input
            id="vin"
            :value="truck.vin"
            @input="truck.vin = $event"
            type="text" :placeholder="$t('Vehicles.vin')" class="col-12 form-group"/>

            <label class="col-12" for="plateNumber">{{$t('Vehicles.plateNumber')}} *</label>
            <regular-input
            id="plateNumber"
            :value="truck.plateNumber"
            @input="truck.plateNumber = $event"
            type="text" :placeholder="$t('Vehicles.plateNumber')" class="col-12 form-group"/>

            <!-- License Fields -->
            <label class="col-12">{{$t('Vehicles.licenseDocuments')}} *</label>
            <div class="col-12 mb-5">
              <table class="table" v-if="truck.licenses && truck.licenses.length>0">
                <tbody>
                  <tr v-for="license, index of truck.licenses">
                    <td class="col-3">
                      <regular-input
                        id="licenseDocumentName"
                        :value="license.documentName"
                        @input="license.documentName = $event"
                        type="text" :placeholder="$t('Vehicles.documentName')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="licenseDocumentExpiry"
                        :value="license.documentExpiry"
                        @input="license.documentExpiry = $event"
                        type="text" :placeholder="$t('Vehicles.documentExpiryPattern')" class="col-12"/>
                    </td>
                    <td class="col-5">
                      <custom-vue-dropzone
                        v-if = "!license.documentUrl"
                        :dropzoneMessage="$t('Vehicles.dropzone')"
                        :maxFile="1"
                        :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                        @dropzoneFile="uploadLicenseDocument"
                      />
                      <p v-if="license.documentUrl">{{$t('Vehicles.uploadedFiles')}}: <a :href="license.documentUrl">{{ license.documentUrl.split('_')[1] }}</a></p>
                    </td>
                    <td class="col-1"><button class="btn btn-light" @click="removeLicenseDocument(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="addLicenseDocument()">{{$t('Users.addDocument')}}</button>
              </div>
            </div>

            <div class="col-12">
              <label for="vin">{{$t('Vehicles.photos')}}</label>
              <custom-vue-dropzone
                :dropzoneMessage="$t('Vehicles.dropzone')"
                :maxFile="10"
                :allowedFileTypes="['.jpeg', '.jpg', '.png']"
                @dropzoneFile="uploadTruckPhotos"
              />
              <p v-if="truck.photos && truck.photos.length>0">{{$t('Vehicles.uploadedFiles')}}: <a class="mr-3" v-for="photo, index of truck.photos" :href="photo">{{ `Photo${index+1}` }}</a></p>
            </div>

            <!-- Other Documents Fields -->
            <label class="col-12 mt-3">{{$t('Vehicles.otherDocuments')}}</label>
            <div class="col-12 mb-5">
              <table class="table" v-if="truck.otherDocuments && truck.otherDocuments.length>0">
                <tbody>
                  <tr v-for="otherDocument, index of truck.otherDocuments">
                    <td class="col-3">
                      <regular-input
                        id="otherDocumentName"
                        :value="otherDocument.documentName"
                        @input="otherDocument.documentName = $event"
                        type="text" :placeholder="$t('Vehicles.documentName')" class="col-12"/>
                    </td>
                    <td class="col-3">
                      <regular-input
                        id="otherDocumentExpiry"
                        :value="otherDocument.documentExpiry"
                        @input="otherDocument.documentExpiry = $event"
                        type="text" :placeholder="$t('Vehicles.documentExpiryPattern')" class="col-12"/>
                    </td>
                    <td class="col-5">
                      <custom-vue-dropzone
                        v-if = "!otherDocument.documentUrl"
                        :dropzoneMessage="$t('Vehicles.dropzone')"
                        :maxFile="1"
                        :allowedFileTypes="['.pdf', '.jpeg', '.jpg', '.png']"
                        @dropzoneFile="uploadOtherDocument"
                      />
                      <p v-if="otherDocument.documentUrl">{{$t('Vehicles.uploadedFiles')}}: <a :href="otherDocument.documentUrl">{{ otherDocument.documentUrl.split('_')[1] }}</a></p>
                    </td>
                    <td class="col-1"><button class="btn btn-light" @click="removeOtherDocument(index)"><strong>&times;</strong></button></td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 text-center">
                <button class="btn btn-light" @click="addOtherDocument()">{{$t('Users.addDocument')}}</button>
              </div>
            </div>

            <label class="col-12" for="associatedTrailer">{{$t('Vehicles.associatedTrailer')}}</label>
            <regular-select
              id="role"
              :value="truck.associatedTrailer"
              @change="truck.associatedTrailer = $event"
              :placeholder="$t('Vehicles.associatedTrailer')" class="col-12 form-group">
                <option v-for="trailer of trailers" :value="trailer.trailerNumber">{{ trailer.trailerNumber }}</option>
            </regular-select>

            <div v-if="truck.associatedTrailer" class="col-12">
              <label class="col-12 mt-4">{{$t('Vehicles.loadCombinations')}}</label>
              <div class="col-12 mb-3">
                <table class="table" v-if="attachedTrailer.loadCombinations && attachedTrailer.loadCombinations.length>0">
                  <thead>
                    <tr>
                      <th class="col-3 text-center">{{ $t('Vehicles.light') }}</th>
                      <th class="col-3 text-center">{{ $t('Vehicles.medium') }}</th>
                      <th class="col-3 text-center">{{ $t('Vehicles.heavy') }}</th>
                      <th class="col-3 text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="loadCombination, index of attachedTrailer.loadCombinations">
                      <td class="col-3">
                        <regular-input
                          id="light"
                          :value="loadCombination.light"
                          @input="loadCombination.light = $event"
                          :disabled="!editLoads"
                          type="number" :placeholder="$t('Vehicles.light')" class="col-12"/>
                      </td>
                      <td class="col-3">
                        <regular-input
                          id="medium"
                          :value="loadCombination.medium"
                          @input="loadCombination.medium = $event"
                          :disabled="!editLoads"
                          type="number" :placeholder="$t('Vehicles.medium')" class="col-12"/>
                      </td>
                      <td class="col-3">
                        <regular-input
                          id="heavy"
                          :value="loadCombination.heavy"
                          @input="loadCombination.heavy = $event"
                          :disabled="!editLoads"
                          type="number" :placeholder="$t('Vehicles.heavy')" class="col-12"/>
                      </td>
                      <td class="col-3"><button class="btn btn-light" v-if="editLoads" @click="removeLoadCombination(index)"><strong>&times;</strong></button></td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 text-center">
                  <button class="btn btn-light" v-if="!editLoads" @click="editLoadCombination(true)">{{$t('Vehicles.editLoadCombination')}}</button>
                  <button class="btn btn-light" v-if="editLoads" @click="addLoadCombination()">{{$t('Vehicles.addLoadCombination')}}</button>
                  <button class="btn btn-light" v-if="editLoads" @click="saveLoadComibations()">{{$t('Vehicles.saveLoadCombination')}}</button>
                </div>
              </div>
            </div>
            <div v-if="modify">
              <label class="col-12" for="associateUser">{{$t('Vehicles.associatedUser')}}</label>
              <regular-datalist-driver
                key="driver"
                :value="truck.associatedUser.chauffeurName"
                @input="truck.associatedUser.chauffeurName = $event.value; truck.associatedUser.chauffeurUid = $event.key; linkTruckToUser()"
                :secondList="liste"
                :placeholder="$t('OrderInfo.modal.driver') + '*'" class="col-12 form-group"/>
            </div>

          </div>
  
          <div class="col-12">
            <p class="red-text">{{feedbackMessage}}</p>
            <button v-if="add" class="btn btn-kne-orange w-100" @click="addTruck(truck.email, truck.password)">{{$t('Vehicles.addTruck')}}</button>
            <button v-else class="btn btn-kne-orange w-100" @click="modifyTruck()">{{$t('Vehicles.modifyTruck')}}</button>
            <button v-if="modify && isAdmin && !isViewer" class="btn btn-danger w-100 mt-2" @click="deleteTruck()">{{$t('Vehicles.deleteTruck')}}</button>
          </div>
        </modal>
      </transition>
  
    </div>
  </template>
  
  <script>
  import Modal from '../module/interface-components/Modal.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import Search from '../module/special-components/Other-components/Search.vue'
  import {db} from '../../firebase'
  // import _ from 'lodash'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import CustomVueDropzone from '../module/special-components/Custom-packages/Custom-VueDropzone.vue'
  import { debounce } from 'lodash'
  
  export default {
    name: 'Vehicles',
  
    components: {
      Modal,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      regularDatalistDriver,
      Search,
      SidebarToggleButton,
      TableElement,
      LoadingRender,
      hoverToolTip,
      CustomVueDropzone
    },
  
    data () {
      return {
        modalTitle: '',
        add: false,
        modify: false,
        search: false,
        editLoads: false,
        key: '',
        truck: {
          truckNumber: '',
          brand: '',
          model: '',
          year: '',
          vin: '',
          plateNumber: '',
          licenses: [],
          photos: [],
          otherDocuments: [],
          associatedTrailer: '',
          associatedUser: {
            chauffeurUid: '',
            chauffeurName: ''
          }
        },
        trucks: [],
        trailers: [],
        attachedTrailer: {
          key: '',
          loadCombinations: []
        },
        fieldsObj: [
          {
            text: this.$t('Vehicles.truckNumber'),
            type: 'truckNumber',
            value: ''
          },
          {
            text: this.$t('Vehicles.brand'),
            type: 'brand',
            value: ''
          },
          {
            text: this.$t('Vehicles.model'),
            type: 'model',
            value: ''
          },
          {
            text: this.$t('Vehicles.year'),
            type: 'year',
            value: ''
          },
          {
            text: this.$t('Vehicles.vin'),
            type: 'vin',
            value: ''
          },
          {
            text: this.$t('Vehicles.plateNumber'),
            type: 'plateNumber',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        isLoading: false,
        feedbackMessage: ''
      }
    },
  
    created () {
      this.isLoading = true
      this.$store.state.isSidebarOpen = false
      this.isScreenSmall = window.innerWidth < 800
  
      this.$bindAsArray('trucks', db.ref('database/transporter').child(this.companyUID).child('user').child('trucks'), null, () => {
        this.isLoading = false
      })

      this.$bindAsArray('liste', db.ref('database/transporter/').child(this.companyUID).child('/liste'))
    },

    watch: {
      'truck.associatedTrailer': function (newVal, oldVal) {
        this.editLoads = false
        this.fetchLoadCombinations()
      }
    },
  
    methods: {
      updateFilterResults (sortResults) {
        this.filterResults = sortResults
      },

      setModalTitle (title) {
        this.modalTitle = title
      },
  
      openModalAddTruck () {
        this.loadTrailersData()
        this.add = true
        this.modalTitle = this.$t('Vehicles.addTruckTitle')
      },

      editLoadCombination (flag) {
        this.editLoads = flag
      },
  
      addTruck () {
        if (!this.checkTruckInfo(this.truck)) return
        db.ref('database/transporter').child(this.companyUID).child('user').child('trucks').push().set(this.truck).then(() => {
          // ======================== ADD CREATED TRUCK LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_TRUCK', 'date': Date.now(), 'truckVIN': this.truck.vin})
          this.clear()
          this.add = !this.add
        }).catch((e) => {
          console.log(e)
        })
      },
  
      linkTruckToUser: debounce(function () {
        const userId = this.truck.associatedUser.chauffeurUid
        const truckId = this.key
        const truck = {
          truckId: truckId,
          truckNumber: this.truck.truckNumber
        }
        if (userId && truckId) {
          db.ref('userInfos').child(this.companyUID).child(userId).child('truck').set(truck)
        }
      }, 300),

      processError (errorCode) {
        if (errorCode === 'TRUCK_CREATE_ERROR') this.feedbackMessage = this.$t('Users.modal.error.email_unavailable')
      },
  
      checkTruckInfo (truck) {
        if (
            !this.validateRequiredField('Vehicles.truckNumber', truck.truckNumber) ||
            !this.validateRequiredField('Vehicles.brand', truck.brand) ||
            !this.validateRequiredField('Vehicles.model', truck.model) ||
            !this.validateRequiredField('Vehicles.year', truck.year) ||
            !this.validateYear(truck.year) ||
            !this.validateRequiredField('Vehicles.vin', truck.vin) ||
            !this.validateRequiredField('Vehicles.plateNumber', truck.plateNumber) ||
            !this.validateLicense() ||
            !this.validateDocuments('Vehicles.otherDocuments', truck.otherDocuments)
          ) {
            return
        }

        return true
      },
  
      validateExpiry (field, value, required = true) {
        if (!required && !value) {
          this.feedbackMessage = ''
          return true
        }
        // Regular expression for mm/yyyy format
        const regex = /^(0[1-9]|1[0-2])\/\d{4}$/
        if (regex.test(value)) {
          this.feedbackMessage = ''
          return true
        } else {
          this.feedbackMessage = this.$t('Users.modal.invalidExpiryFormat') + this.$t(field)
          return false
        }
      },

      validateYear (year) {
        const yearRegex = /^(?:[1-9]\d{3}|0)$/
        if (yearRegex.test(year)) {
          this.feedbackMessage = ''
          return true
        }
        this.feedbackMessage = this.$t('Vehicles.errors.invalidYear')
        return false
      },
  
      validateRequiredField (field, value) {
        if (!value) {
          this.feedbackMessage = this.$t('Users.modal.requiredField') + this.$t(field)
          return false
        } else {
          this.feedbackMessage = ''
          return true
        }
      },

      validateDocuments (field, documents) {
        let validFlag = true
        documents.forEach((document) => {
          if (!this.validateExpiry(field, document.documentExpiry)) {
            this.feedbackMessage = this.$t('Vehicles.errors.invalidExpiryFormat') + this.$t(field)
            validFlag = false
          } else if (!document.documentName || !document.documentUrl) {
            this.feedbackMessage = this.$t('Vehicles.errors.nonEmptyField') + this.$t(field)
            validFlag = false
          }
        })
        return validFlag
      },

      validateLicense () {
        if (this.truck.licenses && this.truck.licenses.length < 1) {
          this.feedbackMessage = this.$t('Vehicles.errors.minimumOneRequired') + this.$t('Vehicles.licenseDocuments')
          return false
        } else {
          if (!this.validateDocuments('Vehicles.licenseDocuments', this.truck.licenses)) {
            return false
          }
          return true
        }
      },

      addOtherDocument () {
        const documentData = this.truck.otherDocuments

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].documentName &&
        documentData[documentData.length - 1].documentExpiry &&
        documentData[documentData.length - 1].documentUrl) ||
        documentData.length === 0) {
          this.truck.otherDocuments.push(
            {
              documentName: '',
              documentExpiry: '',
              documentUrl: ''
            }
          )
        }
      },

      removeOtherDocument (id) {
        this.truck.otherDocuments.splice(id, 1)
      },

      uploadOtherDocument (file) {
        if (file) {
          this.truck.otherDocuments[this.truck.otherDocuments.length - 1].documentUrl = file
        }
      },

      addLicenseDocument () {
        const documentData = this.truck.licenses

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].documentName &&
        documentData[documentData.length - 1].documentExpiry &&
        documentData[documentData.length - 1].documentUrl) ||
        documentData.length === 0) {
          this.truck.licenses.push(
            {
              documentName: '',
              documentExpiry: '',
              documentUrl: ''
            }
          )
        }
      },

      removeLicenseDocument (id) {
        this.truck.licenses.splice(id, 1)
      },

      uploadLicenseDocument (file) {
        if (file) {
          this.truck.licenses[this.truck.licenses.length - 1].documentUrl = file
        }
      },

      uploadTruckPhotos (file) {
        if (file) {
          this.truck.photos.push(file)
        } else {
          this.truck.photos = []
        }
      },

      loadTrailersData () {
        this.$bindAsArray('trailers', db.ref('database/transporter').child(this.companyUID).child('user').child('trailers'), null, () => {
          const attachedTrailers = this.trucks.map((truck) => {
            return truck.associatedTrailer
          }).filter((trailer) => {
            return trailer && !(this.truck.associatedTrailer && trailer === this.truck.associatedTrailer)
          })

          this.trailers = this.trailers.filter((trailer) => {
            return !attachedTrailers.includes(trailer.trailerNumber)
          })

          this.fetchLoadCombinations()
        })
      },

      fetchLoadCombinations () {
        if (this.truck.associatedTrailer) {
          this.attachedTrailer = this.trailers.filter((trailer) => {
            return trailer.trailerNumber === this.truck.associatedTrailer
          }).map((trailer) => {
            return {
              key: trailer['.key'],
              loadCombinations: trailer['loadCombinations']
            }
          })[0] || {key: '', loadCombinations: []}
        }
        if (this.attachedTrailer.key && !this.attachedTrailer.loadCombinations) {
          this.attachedTrailer.loadCombinations = []
        }
      },

      addLoadCombination () {
        const documentData = this.attachedTrailer.loadCombinations

        if ((documentData.length > 0 &&
        documentData[documentData.length - 1].light &&
        documentData[documentData.length - 1].medium &&
        documentData[documentData.length - 1].heavy) ||
        documentData.length === 0) {
          this.attachedTrailer.loadCombinations.push(
            {
              light: null,
              meidum: null,
              heavy: null
            }
          )
        }
      },

      removeLoadCombination (id) {
        this.attachedTrailer.loadCombinations.splice(id, 1)
      },

      saveLoadComibations: function () {
        const combinations = this.attachedTrailer.loadCombinations
        if (combinations.length > 0 &&
            !(combinations[combinations.length - 1].light &&
            combinations[combinations.length - 1].medium &&
            combinations[combinations.length - 1].heavy)) {
              this.feedbackMessage = this.$t('Vehicles.errors.nonEmptyField') + this.$t('Vehicles.loadCombinations')
              return
        }
        db.ref('database/transporter').child(this.companyUID).child('user').child('trailers').child(this.attachedTrailer.key).child('loadCombinations').set(this.attachedTrailer.loadCombinations)
        // ======================== ADD MODIFY USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_TRAILER', 'modifiedTrailerUID': this.attachedTrailer.key, 'date': Date.now()})
        // ======================== ADD MODIFY USER LOG =======================
        this.editLoads = !this.editLoads
      },
  
      modifyTruck: function () {
        if (!this.checkTruckInfo(this.truck)) return
        db.ref('database/transporter').child(this.companyUID).child('user').child('trucks').child(this.key).update(this.truck)
        // ======================== ADD MODIFY USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_TRUCK', 'modifiedTruckUID': this.key, 'date': Date.now(), 'modifiedVIN': this.truck.vin})
        // ======================== ADD MODIFY USER LOG =======================
        this.modify = !this.modify
        this.clear()
      },
  
      deleteTruck: function () {
        db.ref('database/transporter').child(this.companyUID).child('user').child('trucks').child(this.key).remove()
        // ======================== ADD DELETED USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_TRUCK', 'deletedTruckUID': this.key, 'date': Date.now(), 'deletedVIN': this.truck.vin})
        // ======================== ADD DELETED USER LOG =======================
        this.modify = !this.modify
        this.clear()
      },
  
      modifying: function (truck) {
        this.modify = true
        for (var attr in this.truck) {
          if (!(truck[attr] === undefined || truck[attr] === null || typeof truck[attr] !== typeof this.truck[attr])) {
            this.truck[attr] = truck[attr]
          }
        }
        this.loadTrailersData()
        this.key = truck['.key']
      },
  
      clear: function () {
        for (var attr in this.truck) {
          if (typeof this.truck[attr] === 'string') {
            this.truck[attr] = ''
          } else if (Array.isArray(this.truck[attr])) {
            this.truck[attr] = []
          }
        }
        this.feedbackMessage = ''
        this.editLoads = false

        this.$bindAsArray('trucks', db.ref('database/transporter').child(this.companyUID).child('user').child('trucks'), null, () => {
          this.isLoading = false
        })
      },
  
      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
  
    computed: {
      uid () {
        return this.$store.state.user.uid
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isViewer () {
        return this.$store.state.authorization.role === 'Viewer'
      }
    },

    mounted () {
      this.onResize()
      this.$parent.$on('open-add-truck-modal', this.openModalAddTruck)
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    beforeDestroy () {
      this.$parent.$off('open-add-truck-modal', this.openModalAddTruck)
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  .hourlyCheckBox {
    display: flex;
    align-items: center;
  }
  label {
    font-weight: 600;
  }
  </style>
